"use client";
import { useEffect, useState } from "react";
import Image from "next/image";

export default function Hero() {
  const [state, setState] = useState("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setState(localStorage.getItem("state") || "");
  }, []);

  return (
    <div
      className={`h-110 ${state === "SP" ? "bg-[#00813e]" : "bg-[#31b1e1]"} flex justify-center items-center flex-col`}
    >
      <Image
        // src={`${state === "SP" ? "/images/city-sp.svg" : "/images/city-rj.svg"}`}
        src={`${state === "SP" ? "/images/banner/herosp.svg" : "/images/banner/herorj.svg"}`}
        height={200}
        width={450}
        alt="Casa CazéTV"
        className="p-5"
      />
      <span className="w-[90%] max-w-100 text-center text-wrap text-[14px]">
        Transmissão, resenha, jogos ao vivo e a torcida conectada no mesmo
        lugar. Confira a programação, acompanhe cada partida e viva o clima da
        competição dentro da Casa.
      </span>

      <Image
        src="/images/city-comprar.svg"
        height={100}
        width={250}
        alt="Ingresso"
        className="p-5"
        onClick={() =>
          window.open(
            `https://www.sympla.com.br/casacazetv?tracking=SITE_HOME_BANNER_${state}`,
          )
        }
      />

      {/*elements fixed*/}
      <Image
        src="/images/star-right.svg"
        width={30}
        height={20}
        className="absolute top-45 right-0"
        alt="Stars"
        priority
      />

      <Image
        src="/images/star-outline.svg"
        width={40}
        height={20}
        className="absolute top-130 right-4"
        alt="Stars"
        priority
      />

      <Image
        src="/images/star-left.svg"
        width={35}
        height={30}
        className="absolute top-110 left-0"
        alt="Stars"
        priority
      />
    </div>
  );
}
